import { z as zod } from 'zod'

import { DefaultSchemas } from './defaultSchemas'

export const MemberRankingDefaultSchemas = DefaultSchemas

export const MemberRankingTypesDataSchemas = zod.object({
  traderRankingId: zod.number(),
  traderRanking: zod.string(),
})

export const MemberRankingTypesAPISchemas =
  MemberRankingDefaultSchemas.merge(
    zod.object({
      data: zod.array(MemberRankingTypesDataSchemas),
    })
  )

export type MemberRankingTypesAPITypes = zod.infer<
  typeof MemberRankingTypesAPISchemas
>